import ProductGrid from "./components/products-grid";
import CollectionBanner from "./components/shop-banner";
import { useEffect, useState } from "react";
import pagesApi from "./admincomponents/PagesApi";

export default function Shop(){
    const [content, setContent] = useState(null);

    useEffect(() => {
        pagesApi.get("shop").then(setContent).catch(() => setContent({}));
    }, []);

    return(
        <div>
            <CollectionBanner content={content} />
            <ProductGrid />
        </div>
    )
}